// Тумблер в фирменном стиле: мятная дорожка с тёмным бегунком при включении,
// тёмная дорожка с серым бегунком при выключении
export function ToggleSwitch({ checked, onChange, disabled = false, className = '' }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => onChange?.(!checked)}
      className={`relative shrink-0 w-[52px] h-[30px] rounded-[400px] transition-colors duration-200 ${
        checked ? 'bg-[#A1F69E]' : 'bg-[#0B3A3A] border border-[#233636]'
      } ${disabled ? 'opacity-50' : 'cursor-pointer'} ${className}`}
    >
      <span
        className={`absolute top-1/2 -translate-y-1/2 rounded-full transition-all duration-200 ${
          checked ? 'left-[calc(100%-26px)] bg-[#010D0D]' : 'left-[3px] bg-[#5E7A7A]'
        } size-[24px]`}
      />
    </button>
  );
}
